<ui-dialog width="sm">
  <ng-container dialog-title>Das hat nicht funktioniert</ng-container>
  <ng-container dialog-content>
    <div>Es tut uns leid, das hat nicht funktioniert. Bitte überprüfe deine Eingaben..</div>
  </ng-container>
  <ng-container dialog-actions>
    <button mat-flat-button color="accent" class="btn-primary-lg" (click)="zuMeinenEingaben()">
      Zu meinen Eingaben
    </button>
  </ng-container>
</ui-dialog>
